<template>
    <div
        class="animate-slide from-primary-500/30 via-primary-300/40 to-primary-500/30 bg-gradient-to-r bg-no-repeat motion-reduce:animate-none"
    />
</template>
